/** Statuses of a background job (agent run, export, purchase) that is still in flight. */
export const ACTIVE_JOB_STATUSES: ReadonlySet<string> = new Set(["pending", "queued", "running"]);

export function isJobActive(status: string | null | undefined): boolean {
  return !!status && ACTIVE_JOB_STATUSES.has(status);
}
